export default __webpack_public_path__ + "static/media/Prancheta NB.420c8bd8.svg";